<template>
	<div>
        <div class="w100 bgDark header">
            <div class="wContent center" style="width: 1330px">
                <div class="inlineBlock vMid">
                    <router-link to="/*"><img src="../assets/images/logo.png" alt="" srcset="" ></router-link>
                </div>
                <div class="inlineBlock vMid menus">
                    <ul>
                        <li class="floatLeft" v-for="(item, index) in navigation_level1" :key="index">
                            <router-link
							target="_blank"
                            v-if="item.isVaild == 'Y'" 
                            class="fontWhite block textCenter font16"
                            :to="item.navigationUrl == '/home/videoList' || item.navigationUrl == '/serviceSystem' || item.navigationUrl == '/home/quote' || item.navigationUrl == '/home/tradeNews' || item.navigationUrl == '/home/activities' ? item.navigationUrl : (item.navigationUrl + '/' + item.navigationId)" 
                            :class="{'router-link-active': $route.name === item.navigationName}">{{ item.navigationName }}</router-link>
                        </li>
                        <!-- <li class="floatLeft">
                            <router-link class="fontWhite block textCenter font16" to="/home/quote" :class="{'router-link-active': $route.name === '企业报价'}">企业报价</router-link>
                        </li>
                        <li class="floatLeft">
                            <router-link class="fontWhite block textCenter font16" to="/home/tradeNews" :class="{'router-link-active': $route.name === '商情'}">商情</router-link>
                        </li> -->
                    </ul>
                    <div class="clear"></div>
                </div>
                <div class="inlineBlock vMid" style="float: right; margin-top: 18px;">
                    <a href="javascript:;" class="little-icon search inlineBlock vMid" v-show="!showSearchCover" @click="changeSearchCover(1)"></a>
                    <a href="javascript:;" class="little-icon search-del inlineBlock vMid" v-show="showSearchCover" @click="changeSearchCover(2)"></a>
                    <span class="fontLighter font20 inlineBlock vMid col-line">|</span>
                    <a href="javascript:;" class="little-icon ava inlineBlock vMid"></a>
                    <div class="inlineBlock vMid" style="margin-left: 10px;">
                        <a @click="showLoginDialog" v-show="!isLogin" href="javascript:;" class="font14 fontBold inlineBlock" style="width: fit-content; color: #ccc">登录/注册</a>
                        <a class="fontBold font14 pointer inlineBlock ellipsis vBot" style="padding-right: 5px; color: #ccc; width: 70px;" v-show="isLogin" @click="goSelfPage()" :title="userInfoAll.username">
                            {{ userInfoAll.username }}
                        </a>
                        <a href="javascript:;" class="font14 fontBold" style="color: #ccc" @click="logout()" v-show="isLogin">退出</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="w100 search-box" id="searchCover">
            <div class="center" style="width: 800px; margin-top: 40px;">
                <el-input placeholder="" v-model="input" class="input-with-select middle-c-search">
                    <el-select v-model="select" slot="prepend" placeholder="请选择">
                        <el-option label="资讯" value="1"></el-option>
                        <el-option label="报告" value="2"></el-option>
                    </el-select>
                    <el-button slot="append" @click="goSearchPage()">搜索</el-button>
                </el-input>
                
            </div>
            <div class="center" style="width: 800px;">
                <h3 class="hot-title fontLight font16 mw-modular-box">热门搜索</h3>
                <a @click="goSearchPage(item)" class="font16 pointer fontDark inlineBlock vMid" style="margin-right: 45px; margin-bottom: 20px;" v-for="(item, index) in label_list" :key="index">{{ item.labelTxt }}</a>
            </div>
        </div>

        <Login ref="loginDialog"></Login>

        
	</div>
</template>

<script>
    import $ from 'jquery'
    import '../assets/js/gVerify'
    import { mw_validate, baseUrl } from '../assets/js/common'
    import Login from '../templates/loginControl'
	export default {
	    name: 'Header',
	    components: { Login },
	    data () {
	        return {
                showSearchCover: false,
                userPhoto: require('../assets/images/user.jpg'),
                isLogin: false, // 是否登录过
                userInfo: {}, // 注册成功后返回用户信息
                userInfoAll: {}, // 根据用户主键id获取的全部信息

                /* ******** 搜索补分 ************ */
                input: '',
                select: '1',
                label_list: [],
                /* ******** 搜索补分 ************ */

                /********** 菜单部分 ***********/
                navigation_level1: [],
                /********** 菜单部分 ***********/
                
            }
	    },
	    mounted () {
            // 初始化内容
            this.getUserInfo();  //获取用户信息
            this.findPriorLabel(); // 获取搜索关键字
	    },
	    methods: {

            // 是否展示搜索
            changeSearchCover (type) {
                type == 1 ? $('#searchCover').show(800) : $('#searchCover').hide(800);
                this.showSearchCover = type == 1 ? true : false;
                type == 1 ? $('body').css({'height': $(document).height(), 'overflow': 'hidden'}) : $('body').css({'height': 'auto', 'overflow': 'auto'})
            },

            // 弹出登录框
            showLoginDialog () {
                this.$refs.loginDialog.init();
            },

            /* 获取cookies */
            getUserInfo () {
                const self = this;
                const token_cyw = self.$cookies.get('token_cyw');
                if (token_cyw) {
                    self.getUserAllInfo(token_cyw);
                } else {
                    self.isLogin = false;
                    this.findNaTree('N');
                }
            },
            /* 获取用户全部信息 */
            getUserAllInfo (token_cyw, type) {
                const self = this;

                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.business}/api/user/find/${res_1.data.id}`, {}).then(res => {
                            if(res.status == 200) {
                                if (res.data == null) {
                                    self.$message.error('未获取到身份信息')
                                } else {
                                    self.userInfoAll = res.data;
                                    self.isLogin = true;
                                    self.findNaTree('Y');
                                    if (type) {
                                        self.updateLoginUser(); // 获取到用户身份信息后调用, 只有注册或登录时记录
                                    }
                                }
                            } else {
                                self.$message.error(res.message)
                                self.isLogin = false;
                                self.$router.go(0);
                            }
                        }).catch(err => {
                            self.$message.error('未获取到身份信息');
                        })
                    } else {
                        self.$message.error(res_1.msg);
                        self.$cookies.remove('token_cyw');
                        self.$router.go(0);
                    }
                }).catch(err_1 => {
                    self.$message.error('请求错误');
                })
            },

/* ******************************* 获取搜索关键字前十 ********************************** */
            findPriorLabel () {
                const self = this;
                self.$get(`${baseUrl.cyw}/inforLabel/findPriorLabel`, {}).then(res => {
                    if (res.code == 0) {
                        self.label_list = res.data;
                    } else {
                        self.$message.error(res.message)
                    }
                }).catch(err => {
                    self.$message.error('未获取到关键词信息')
                })
            },
            goSearchPage (item) {
                const self = this;
                if (item) {
                    self.$get(`${baseUrl.cyw}/inforLabel/addClickNum/${item.labelId}`, {}).then(res => {
                        if (res.code == 0) {
                            $('#searchCover').hide();
                            self.$router.push(`/home/searchPage?key=${item.labelTxt}&type=1`)
                        } else {
                            self.$message.error('跳转失败，请重试！')
                        }
                    }).catch(err => {
                        self.$message.error('跳转失败，请重试！')
                    })
                } else {
                    $('#searchCover').hide();
                    self.$router.push(`/home/searchPage?key=${encodeURI(self.input)}&type=${self.select}`)
                }
            },
/* ******************************* 获取搜索关键字前十 ********************************** */

/* ******************************* 获取一级菜单 ********************************** */
            findNaTree (visit) {
                const self = this;
                self.$get(`${baseUrl.cyw}/navigation/findNaTree?visitLimit=${visit}`, {}).then(res => {
                    if (res.code == 0) {
                        self.navigation_level1 = res.data;
                    } else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    self.$message.error('未获取到导航信息');
                })
            },

/* ******************************* 获取一级菜单 ********************************** */

/****************** 退出登录 ********************************************/
            logout () {
                const self = this;
                self.$confirm('确定退出吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const token_cyw = self.$cookies.get('t');
                    self.$get(`${baseUrl.business}/api/user/logout/${token_cyw}`, {}).then(res => {
                        if (res.status == 200) {
                            self.$message('退出成功');
                            self.isLogin = false;
                            self.$cookies.remove('token_cyw');
                            this.$router.go(0); 
                        } else {
                            self.$message.error(res.msg);
                        }
                    }).catch(err => {
                        self.$message.error('退出失败，请重试');
                    })
                })
                
            },
/****************** 退出登录 ********************************************/

/* **************** 跳转到个人页 */
            goSelfPage () {
                this.$router.push(`/home/selfPage`)
            },
/* **************** 跳转到个人页 */

/* **************** 记录点击 *** */
            updateLoginUser () {
                const self = this;
                self.$get(`${baseUrl.crm}/business/cyw/openapi/updateLoginUserVistNumAndLoginTime.json?id=${self.userInfoAll.id}`, {}).then(res => {
                    this.$router.go(0); 
                })
            },
/* **************** 记录点击 *** */

        },
	}
</script>

<style scoped>
    .menus { margin: 5px 0px 5px 40px; }
    .menus .router-link-active, .menus a:hover { background-color: #a30000; }
    .menus a { padding: 13px 12px; margin-right: 2px; }
    .col-line { padding: 0 15px; margin-top: -2px; }
    .header { padding: 10px 0; }
    .little-icon { width: 18px; height: 18px; }
    .search { background: url('../assets/images/index_search.png') no-repeat; background-size: 100% 100%; }
    .search-del { background: url('../assets/images/index_search_del.png') no-repeat; background-size: 100% 100%; position: relative;}
    .search-del::before { content: ' '; border: 2px solid #a30000; position: absolute; width: 30px; left: -8px; top: -30px; }
    .search:hover { background: url('../assets/images/index_search1.png') no-repeat; background-size: 100% 100%; }
    .ava { background: url('../assets/images/index_ava.png') no-repeat; background-size: 100% 100%; }
    .ava:hover { background: url('../assets/images/index_ava1.png') no-repeat; background-size: 100% 100%; }
    .search-box { position: fixed; top: 83px; left: 0; height: 100vh; width: 100%; background: rgba(255, 255, 255, 0.98); z-index: 3; display: none; }
    .middle-c-search { margin-top: 5px }
    .hot-title { font-weight: 500; }
</style>
